// User roles
export const USER_ROLES = {
  ADMIN: 'admin',
  TEACHER: 'teacher', 
  STUDENT: 'student',
  MEMBER: 'member'
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

// Role display names
export const ROLE_DISPLAY_NAMES: Record<UserRole, string> = {
  [USER_ROLES.ADMIN]: 'Quản trị viên',
  [USER_ROLES.TEACHER]: 'Giáo viên',
  [USER_ROLES.STUDENT]: 'Học sinh',
  [USER_ROLES.MEMBER]: 'Thành viên'
};

// Role colors for UI
export const ROLE_COLORS: Record<UserRole, 'error' | 'warning' | 'info' | 'default'> = {
  [USER_ROLES.ADMIN]: 'error',
  [USER_ROLES.TEACHER]: 'warning',
  [USER_ROLES.STUDENT]: 'info',
  [USER_ROLES.MEMBER]: 'default'
};

// Permission functions
export const rolePermissions = {
  // Can create quizzes and upload documents
  canCreateQuizzes: (role?: UserRole): boolean => {
    return role === USER_ROLES.ADMIN || role === USER_ROLES.TEACHER;
  },

  // Can manage users (admin only)
  canManageUsers: (role?: UserRole): boolean => {
    return role === USER_ROLES.ADMIN;
  },

  // Can edit/delete documents (admin and teacher only)
  canManageDocuments: (role?: UserRole): boolean => {
    return role === USER_ROLES.ADMIN || role === USER_ROLES.TEACHER;
  },

  // Can view documents (admin and teacher only)
  canViewDocuments: (role?: UserRole): boolean => {
    return role === USER_ROLES.ADMIN || role === USER_ROLES.TEACHER;
  },

  // Can take quizzes (all roles)
  canTakeQuizzes: (role?: UserRole): boolean => {
    return !!role; // All authenticated users can take quizzes
  },

  // Can view quiz history (all roles)
  canViewHistory: (role?: UserRole): boolean => {
    return !!role; // All authenticated users can view their history
  }
};

// Helper function to get role display name
export const getRoleDisplayName = (role?: UserRole): string => {
  return role ? ROLE_DISPLAY_NAMES[role] : 'Không xác định';
};

// Helper function to get role color
export const getRoleColor = (role?: UserRole): 'error' | 'warning' | 'info' | 'default' => {
  return role ? ROLE_COLORS[role] : 'default';
}; 